import React from "react";
import logo from "../assets/sava_logo.PNG";
import LinearProgress from "@mui/material/LinearProgress";
import { Box, Container } from "@mui/material";

const Loader = () => {
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh", // Ensures the container takes the full viewport height
      }}>
      <Box
        sx={{
          borderRadius: "50%",
          width: 100, // Set the desired size for the container
          height: 100, // Set the desired size for the container
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center", // Center the image and progress bar
        }}>
        <img
          src={logo} // Replace with your image source
          alt="loader"
          style={{
            width: "50%",
            height: "50%",
            objectFit: "cover", // Ensures the image covers the area
          }}
        />

        <Box sx={{ width: "100%", marginTop: "10px" }}>
          <LinearProgress />
        </Box>
      </Box>
    </Container>
  );
};

export default Loader;
